import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import langTr from "../i18n/locales/tr/translations.json";
import langEn from "../i18n/locales/en/translations.json";

console.log(langTr);
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: true,
    fallbackLng: "tr",
    resources: {
      tr: {
        translation: langTr,
      },
      en: {
        translation: langEn,
      },
    },
  });

export default i18next